import { fetchData } from "@/lib/api/fetchData";

export const insertUserPermission = async (userPermission) => {
  try {
    const res = await fetchData("/users/permissions", {
      method: "POST",
      body: userPermission,
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to insert user");
  }
};

export const updateUserPermission = async (userPermission) => {
  try {
    const res = await fetchData(`/users/permissions/${userPermission.id}`, {
      method: "PATCH",
      body: userPermission,
      contentType: "application/merge-patch+json",
    });

    return res.data;
  } catch (error) {
    console.error(error);
    throw new Error("Failed to update user");
  }
};
